// I due fogli del telefono della Fatturazione (filtri e strumenti), estratti
// dalla pagina il 26/10/2026 per il tetto righe. Stesso comportamento.
import { Link } from "react-router-dom";
import { BottomSheet } from "@/shared/ui/BottomSheet";
import { risolviCanale } from "./ChannelCell";
import { DateRangeFilter, RANGE_VUOTO, type DateRange } from "./DateRangeFilter";
import { LegendaElenco } from "./TablePopovers";
import type { CampoData } from "../types";

export interface FogliTelefonoProps {
  filtriAperti: boolean;
  setFiltriAperti: (v: boolean) => void;
  strumentiAperti: boolean;
  setStrumentiAperti: (v: boolean) => void;
  channels: string[];
  channelFilter: string;
  setChannelFilter: (c: string) => void;
  range: DateRange;
  setRange: (r: DateRange) => void;
  campoData: CampoData;
  setCampoData: (c: CampoData) => void;
  righe: number;
  exportBusy: boolean;
  downloadXlsx: () => void;
  setManualOpen: (v: boolean) => void;
  senzaPermesso: { disabled?: true; title?: string };
}

export function FogliTelefono({
  filtriAperti,
  setFiltriAperti,
  strumentiAperti,
  setStrumentiAperti,
  channels,
  channelFilter,
  setChannelFilter,
  range,
  setRange,
  campoData,
  setCampoData,
  righe,
  exportBusy,
  downloadXlsx,
  setManualOpen,
  senzaPermesso,
}: FogliTelefonoProps) {
  return (
    <>
      <BottomSheet
        open={filtriAperti}
        onClose={() => setFiltriAperti(false)}
        title="Filtri"
        footer={
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                setChannelFilter("");
                setRange(RANGE_VUOTO);
              }}
              className="om-press h-12 flex-1 rounded-xl border border-line-2 bg-card text-[15px] font-semibold text-ink"
            >
              Azzera
            </button>
            <button
              type="button"
              onClick={() => setFiltriAperti(false)}
              className="om-press h-12 flex-[2] rounded-xl bg-ink text-[15px] font-semibold text-on-ink"
            >
              Vedi {righe} {righe === 1 ? "riga" : "righe"}
            </button>
          </div>
        }
      >
        <section className="border-b border-line py-4">
          <h3 className="mb-2.5 text-[15px] font-bold text-ink">Canale</h3>
          <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Canale">
            {["", ...channels].map((c) => {
              const on = channelFilter === c;
              return (
                <button
                  key={c || "tutti"}
                  type="button"
                  role="radio"
                  aria-checked={on}
                  onClick={() => setChannelFilter(c)}
                  className={[
                    "om-press inline-flex h-10 items-center rounded-full border-[1.5px] px-4 text-[14px]",
                    on
                      ? "border-ink bg-ink font-semibold text-on-ink"
                      : "border-line-2 bg-card font-medium text-ink",
                  ].join(" ")}
                >
                  {c ? risolviCanale(c).nome : "Tutti"}
                </button>
              );
            })}
          </div>
        </section>
        <section className="py-4">
          <h3 className="mb-2.5 text-[15px] font-bold text-ink">Periodo</h3>
          <DateRangeFilter
            value={range}
            onChange={setRange}
            campo={campoData}
            onCampoChange={setCampoData}
          />
        </section>
      </BottomSheet>

      <BottomSheet
        open={strumentiAperti}
        onClose={() => setStrumentiAperti(false)}
        title="Strumenti"
      >
        <div className="flex flex-col gap-2 pt-1">
          <button
            type="button"
            onClick={() => {
              setStrumentiAperti(false);
              setManualOpen(true);
            }}
            {...senzaPermesso}
            className="om-press h-12 rounded-xl bg-accent-2 text-[15px] font-semibold text-white disabled:opacity-50"
          >
            + Riga manuale
          </button>
          <button
            type="button"
            disabled={exportBusy}
            onClick={() => downloadXlsx()}
            className="om-press h-12 rounded-xl border border-line-2 bg-card text-[15px] font-semibold text-ink disabled:opacity-50"
          >
            {exportBusy ? "Esporto…" : "Scarica in Excel questa vista"}
          </button>
          <Link
            to="/fatturazione/corrispettivi"
            className="om-press flex h-12 items-center justify-center rounded-xl border border-line-2 bg-card text-[15px] font-semibold text-ink"
          >
            Corrispettivi Amazon
          </Link>
        </div>
        <details className="group mt-4 rounded-xl border border-line bg-card">
          <summary className="flex min-h-[48px] cursor-pointer list-none items-center justify-between px-4 text-[15px] font-semibold text-ink [&::-webkit-details-marker]:hidden">
            Legenda: cosa vogliono dire le scritte
            <span aria-hidden="true" className="transition-transform group-open:rotate-180">
              ⌄
            </span>
          </summary>
          <div className="px-4 pb-4">
            <LegendaElenco grande />
          </div>
        </details>
      </BottomSheet>
    </>
  );
}
